module.exports = __webpack_public_path__ + "static/media/python.b5da0d0d.png";